import { z } from 'zod'
import { isValidUsPhone, US_PHONE_ERROR } from '../lib/phone'

// A recruiter's school is chosen from the curated `schools` table at signup and
// verified against their email domain, so only a reference is ever accepted.
export const schoolRefSchema = z.object({ id: z.string().uuid('Invalid school ID') })

export const recruiterContactInfoSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(50),
  lastName: z.string().min(1, 'Last name is required').max(50),
  phone: z.string().refine(isValidUsPhone, US_PHONE_ERROR),
  email: z.string().email('Invalid email address'),
  address: z
    .object({
      street: z.string().min(1, 'Street address is required'),
      city: z.string().min(1, 'City is required'),
      state: z.string().min(2, 'State is required').max(2),
      zipCode: z.string().regex(/^\d{5}(-\d{4})?$/, 'Invalid ZIP code'),
    })
    .optional(),
})

export const recruitingFocusSchema = z.object({
  events: z.array(z.string()).optional(),
  academicRequirements: z.object({
    minGPA: z.number().min(0).max(4.0).optional(),
    minSAT: z.number().int().min(400).max(1600).optional(),
    minACT: z.number().int().min(1).max(36).optional(),
  }),
})

export const recruiterProfileSchema = z.object({
  // Set from the school chosen at signup and verified against the recruiter's
  // email, so profile saves normally omit it. Still validated and re-checked
  // server-side when present.
  school: schoolRefSchema.optional(),
  position: z.string().min(1, 'Position is required'),
  bio: z.string().max(1000).optional(),
  profilePhoto: z.string().url().optional(),
  contactInfo: recruiterContactInfoSchema,
  recruitingFocus: recruitingFocusSchema,
})

export const updateRecruiterProfileSchema = recruiterProfileSchema.partial()
